<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <i-l-u/>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ILU from "./components/ILU";

export default {
  name: "App",
  components: {
    ILU
  }
};
</script>
